// ======================================================================
// FILE:
// src/modules/service_crm/visits/components/VisitFilterBar.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Service Visit Filters
// ======================================================================

import React, {
  useState,
} from "react";

export default function VisitFilterBar({

  filters = {},

  onApply,

}) {

  const [localFilters, setLocalFilters] =
    useState({

      q:
        filters.q || "",

      engineer:
        filters.engineer || "",

      status:
        filters.status || "",

    });

  const updateField = (
    field,
    value
  ) => {

    setLocalFilters((prev) => ({

      ...prev,

      [field]: value,

    }));

  };

  const applyFilters = () => {

    const cleaned = {};

    Object.keys(
      localFilters
    ).forEach((key) => {

      if (

        localFilters[key] !== "" &&
        localFilters[key] !== null &&
        localFilters[key] !== undefined

      ) {

        cleaned[key] =
          localFilters[key];

      }

    });

    onApply(
      cleaned
    );

  };

  const clearFilters = () => {

    const reset = {

      q: "",

      engineer: "",

      status: "",

    };

    setLocalFilters(
      reset
    );

    onApply({});

  };

  return (

    <div

      style={{

        background: "#fff",

        borderRadius: 14,

        padding: 20,

        marginBottom: 20,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",

      }}

    >

      <div

        style={{

          fontSize: 16,

          fontWeight: 700,

          marginBottom: 18,

        }}

      >

        Search & Filters

      </div>

      <div

        style={{

          display: "grid",

          gridTemplateColumns:
            "repeat(auto-fit,minmax(250px,1fr))",

          gap: 14,

        }}

      >

        <div>

          <label>

            Search

          </label>

          <input

            type="text"

            value={
              localFilters.q
            }

            onChange={(e) =>
              updateField(
                "q",
                e.target.value
              )
            }

            placeholder="
Ticket / Customer"

            style={inputStyle}

          />

        </div>

        <div>

          <label>

            Engineer

          </label>

          <input

            type="text"

            value={
              localFilters.engineer
            }

            onChange={(e) =>
              updateField(
                "engineer",
                e.target.value
              )
            }

            placeholder="
Engineer Name"

            style={inputStyle}

          />

        </div>

        <div>

          <label>

            Status

          </label>

          <select

            value={
              localFilters.status
            }

            onChange={(e) =>
              updateField(
                "status",
                e.target.value
              )
            }

            style={inputStyle}

          >

            <option value="">
              All
            </option>

            <option value="OPEN">
              OPEN
            </option>

            <option value="ASSIGNED">
              ASSIGNED
            </option>

            <option value="RESOLVED">
              RESOLVED
            </option>

            <option value="CLOSED">
              CLOSED
            </option>

          </select>

        </div>

      </div>

      <div

        style={{

          display: "flex",

          justifyContent:
            "flex-end",

          gap: 10,

          marginTop: 18,

        }}

      >

        <button

          onClick={
            clearFilters
          }

          style={clearButtonStyle}

        >

          Clear

        </button>

        <button

          onClick={
            applyFilters
          }

          style={applyButtonStyle}

        >

          Apply Filters

        </button>

      </div>

    </div>

  );

}

const inputStyle = {

  width: "100%",

  padding: "10px 12px",

  border: "1px solid #ced4da",

  borderRadius: 8,

  marginTop: 6,

};

const clearButtonStyle = {

  background: "#fff",

  border: "1px solid #ced4da",

  padding: "8px 14px",

  borderRadius: 8,

  cursor: "pointer",

};

const applyButtonStyle = {

  background: "#0d6efd",

  color: "#fff",

  border: "none",

  padding: "8px 14px",

  borderRadius: 8,

  cursor: "pointer",

};